import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled, { keyframes } from 'styled-components'
import { Event as EventModel } from '../../../model/Event'
import { useConfigContext } from '../../App/App'
import Card from './Card/Card'
import Content from './Content/Content'
import Direction from './Direction/Direction'
import Information from './Information/Information'

const flipInX = keyframes`
  from {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
`

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  margin: 1rem 0;

  .direction {
    display: flex;
    justify-content: center;
  }

  &.event-enter-active {
    animation: ${flipInX};
    animation-duration: 1s;
    animation-fill-mode: both;
    backface-visibility: visible !important;
  }
`

interface IProps {
  event: EventModel
  isPortraitOriented: boolean
}

const Event = ({ event, isPortraitOriented }: IProps) => {
  const { showEventLogo } = useConfigContext()
  const { room, logoFilePath } = event
  const showDirection = room && room.route && room.route.direction
  const showLogo = logoFilePath && showEventLogo

  return (
    <Wrapper>
      {event.fromDate !== null && event.toDate !== null &&
            <Card event={event}>
            <Container fluid={true}>
              <Row className="justify-content-between h-100">
                <Col
                  className={`align-self-start ${isPortraitOriented ? 'h-100' : 'align-self-sm-center'}`}
                  xs="2"
                  sm={showLogo ? '3' : (isPortraitOriented ? '3' : '2')}
                >
                  <Information event={event} isPortraitOriented={isPortraitOriented} showLogo={showLogo}/>
                </Col>
                <Col
                  className={`align-self-start ${isPortraitOriented ? 'h-100' : 'align-self-sm-center'}`}
                  xs="8"
                  sm={showLogo ? '7' : (isPortraitOriented ? '7' : '8')}
                >
                  <Content event={event} isPortraitOriented={isPortraitOriented}/>
                </Col>
                <Col
                  className={`direction align-self-center ${isPortraitOriented ? '' : 'align-self-sm-center'}`}
                  xs="2"
                  sm={isPortraitOriented ? '2' : '1'}
                  md="2"
                >
                  {showDirection && <Direction route={room.route}/>}
                </Col>
              </Row>
            </Container>
          </Card>
      }

    </Wrapper>
  )
}

export default Event
